import React from 'react'
import {Flex, SVGButton} from '/app/src/component'

class DotNavigation extends React.Component {
    render() {
        const {activePage, pages, backButton, nextButton, finishButton} = this.props
        return (
            <Flex grow width='100%' hAlignContent='center' vAlignContent='bottom'>
            {activePage > 1 &&
                <SVGButton
                    text='Tillbaka'
                    color='black' hover='blue'
                    w='100px' h='40px'
                    border
                    fontSize='18px'
                    onClick={backButton}
                />
            }
            {activePage > 1 && <Flex width='20px'/>}

            {activePage < pages &&
                <SVGButton
                    text='Nästa'
                    color='black' hover='blue'
                    w='100px' h='40px'
                    border
                    fontSize='18px'
                    onClick={nextButton}
                />
            }
            {activePage === pages &&
                <SVGButton
                    text='Avsluta'
                    color='black' hover='blue'
                    w='100px' h='40px'
                    border
                    fontSize='18px'
                    onClick={finishButton}
                />
            }
            </Flex>
        );
    }
}

DotNavigation.propTypes = {

}


export default DotNavigation



// WEBPACK FOOTER //
// ./src/component/DotPagination/DotNavigation.js